export default __webpack_public_path__ + "08a97bf6.jpg";